export const MOBILE = "600px";
